import React from 'react';
export var Column = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "flex flex-auto min-h-full flex-col h-auto lg:flex-row" }, children));
};
